import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _typeof from "@babel/runtime/helpers/typeof";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.error.to-string.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { getGlobalProperty } from "@faire/web--source/common/globals/getGlobalProperty";
import { isError } from "@faire/web--source/common/typescriptUtils";
import { isPrerender } from "@faire/web--source/common/user-agent/isPrerender";
import { isRobot } from "@faire/web--source/common/user-agent/isRobot";
var isRawResponse = function isRawResponse(r) {
  if (!r || _typeof(r) !== "object") {
    return false;
  }
  var obj = r;
  var isSuccessResponse = "data" in obj && typeof obj["status"] === "number" && "headers" in obj;
  var isFailureResponse = "error" in obj && isError(obj.error);
  return isSuccessResponse || isFailureResponse;
};
var getFaireApiNamespace = function getFaireApiNamespace() {
  var faire = getGlobalProperty("faire");
  if (!faire) {
    throw new Error("Faire global not found");
  }
  var api = faire.api || (faire.api = {});
  return api;
};
export var REQUEST_HANDLER_GLOBAL_KEY = "faire.api.handler";
export var getRequestHandler = function getRequestHandler() {
  return getGlobalProperty(REQUEST_HANDLER_GLOBAL_KEY);
};
/**
 * Sets the global request handler, i.e. global.faire["api"]["handler"].
 * The request handler is later resolved via getRequestHandler (getGlobalProperty("faire.api.handler")),
 * so in a Zone context (i.e. SSR), this should be done using Zone.fork, setting "faire.api.handler".
 */
export var setRequestHandler = function setRequestHandler(handler) {
  getFaireApiNamespace().handler = handler;
};
export var REQUEST_INTERCEPTOR_GLOBAL_KEY = "faire.api.requestInterceptors";
export var getRequestInterceptors = function getRequestInterceptors() {
  var _getGlobalProperty;
  var requestInterceptors = (_getGlobalProperty = getGlobalProperty(REQUEST_INTERCEPTOR_GLOBAL_KEY)) !== null && _getGlobalProperty !== void 0 ? _getGlobalProperty : [];
  return Object.freeze(requestInterceptors.slice(0));
};
/**
 * Sets a global request interceptor.
 * The request interceptors are invoked before the request handler called.
 */
export var addRequestInterceptor = function addRequestInterceptor(interceptor) {
  var _getFaireApiNamespace;
  var interceptors = getFaireApiNamespace().requestInterceptors = (_getFaireApiNamespace = getFaireApiNamespace().requestInterceptors) !== null && _getFaireApiNamespace !== void 0 ? _getFaireApiNamespace : [];
  interceptors.push(interceptor);
};
export var RESPONSE_INTERCEPTOR_GLOBAL_KEY = "faire.api.responseInterceptors";
export var getResponseInterceptors = function getResponseInterceptors() {
  var _getGlobalProperty2;
  var repsonseInterceptors = (_getGlobalProperty2 = getGlobalProperty(RESPONSE_INTERCEPTOR_GLOBAL_KEY)) !== null && _getGlobalProperty2 !== void 0 ? _getGlobalProperty2 : [];
  return Object.freeze(repsonseInterceptors.slice(0));
};
/**
 * Sets a global request interceptor.
 * The request interceptors are invoked before the request handler called.
 */
export var addResponseInterceptor = function addResponseInterceptor(interceptor) {
  var _getFaireApiNamespace2;
  var interceptors = getFaireApiNamespace().responseInterceptors = (_getFaireApiNamespace2 = getFaireApiNamespace().responseInterceptors) !== null && _getFaireApiNamespace2 !== void 0 ? _getFaireApiNamespace2 : [];
  interceptors.push(interceptor);
};
export function request(_x) {
  return _request.apply(this, arguments);
}
/**
 * Sets a global event interceptor.
 * The event interceptors are invoked when an event is tracked.
 */
function _request() {
  _request = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(config) {
    var requestHandler, interceptors, _iterator, _step, _i, response, _getResponseIntercept, _interceptors, _iterator2, _step2, i;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          requestHandler = getRequestHandler();
          if (!(requestHandler === undefined)) {
            _context.next = 3;
            break;
          }
          throw new Error("Error: request handler does not exist! Please use setRequestHandler() to set one.");
        case 3:
          if (!(config.ignoreDuringPrerender && isPrerender())) {
            _context.next = 5;
            break;
          }
          return _context.abrupt("return", undefined);
        case 5:
          if (!(config.ignoreForRobots && isRobot())) {
            _context.next = 7;
            break;
          }
          return _context.abrupt("return", undefined);
        case 7:
          if ((config.method === "post" || config.method === "put") && !config.data) {
            config.data = {};
          }
          interceptors = getRequestInterceptors();
          _iterator = _createForOfIteratorHelper(interceptors);
          _context.prev = 10;
          _iterator.s();
        case 12:
          if ((_step = _iterator.n()).done) {
            _context.next = 19;
            break;
          }
          _i = _step.value;
          _context.next = 16;
          return _i(config);
        case 16:
          config = _context.sent;
        case 17:
          _context.next = 12;
          break;
        case 19:
          _context.next = 24;
          break;
        case 21:
          _context.prev = 21;
          _context.t0 = _context["catch"](10);
          _iterator.e(_context.t0);
        case 24:
          _context.prev = 24;
          _iterator.f();
          return _context.finish(24);
        case 27:
          _context.prev = 27;
          _context.next = 30;
          return requestHandler(config);
        case 30:
          response = _context.sent;
          _context.next = 36;
          break;
        case 33:
          _context.prev = 33;
          _context.t1 = _context["catch"](27);
          if (isError(_context.t1)) {
            response = {
              error: _context.t1
            };
          } else {
            response = {
              error: new Error("Unexpected error thrown while handling ".concat(config.method, " ").concat(config.url))
            };
          }
        case 36:
          if (!isRawResponse(response)) {
            _context.next = 61;
            break;
          }
          _interceptors = (_getResponseIntercept = getResponseInterceptors()) !== null && _getResponseIntercept !== void 0 ? _getResponseIntercept : [];
          _iterator2 = _createForOfIteratorHelper(_interceptors);
          _context.prev = 39;
          _iterator2.s();
        case 41:
          if ((_step2 = _iterator2.n()).done) {
            _context.next = 48;
            break;
          }
          i = _step2.value;
          _context.next = 45;
          return i(config, response);
        case 45:
          response = _context.sent;
        case 46:
          _context.next = 41;
          break;
        case 48:
          _context.next = 53;
          break;
        case 50:
          _context.prev = 50;
          _context.t2 = _context["catch"](39);
          _iterator2.e(_context.t2);
        case 53:
          _context.prev = 53;
          _iterator2.f();
          return _context.finish(53);
        case 56:
          if (!("error" in response)) {
            _context.next = 60;
            break;
          }
          throw response.error;
        case 60:
          if (config.rawResponse !== true) {
            response = response.data;
          }
        case 61:
          return _context.abrupt("return", response);
        case 62:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[10, 21, 24, 27], [27, 33], [39, 50, 53, 56]]);
  }));
  return _request.apply(this, arguments);
}
export var addEventInterceptor = function addEventInterceptor(interceptor) {
  var _getFaireEventsNamesp;
  var interceptors = getFaireEventsNamespace().interceptors = (_getFaireEventsNamesp = getFaireEventsNamespace().interceptors) !== null && _getFaireEventsNamesp !== void 0 ? _getFaireEventsNamesp : [];
  interceptors.push(interceptor);
};
var getFaireEventsNamespace = function getFaireEventsNamespace() {
  var faire = getGlobalProperty("faire");
  if (!faire) {
    throw new Error("Faire global not found");
  }
  var events = faire.events || (faire.events = {});
  return events;
};